import type { CampaignAnalyticsGranularity } from "@adpilot/shared";
import { queryOptions } from "@tanstack/react-query";
import { fetchCampaignAnalytics } from "@/lib/dashboard-api";
import type { ReportingTimeZone } from "@/lib/reporting-time-zone";
import { type ReportingPeriod, resolveReportingPeriod } from "@/stores/reporting-period";

interface CampaignPerformanceScope {
  campaignId: string;
  shopId: string | null;
  range: ReportingPeriod;
  timeZone: ReportingTimeZone;
  granularity: CampaignAnalyticsGranularity;
}

export function campaignDetailPerformanceQuery(scope: CampaignPerformanceScope) {
  const dates = resolveReportingPeriod(scope.range, new Date(), scope.timeZone);
  return queryOptions({
    queryKey: [
      "campaign",
      scope.campaignId,
      "performance",
      scope.shopId,
      dates.startDate,
      dates.endDate,
      scope.timeZone,
      scope.granularity,
    ],
    queryFn: ({ signal }) => {
      if (!scope.shopId) throw new Error("Campaign shop is unavailable");
      return fetchCampaignAnalytics(
        {
          campaignId: scope.campaignId,
          shopIds: [scope.shopId],
          range: { type: "custom", ...dates },
          timeZone: scope.timeZone,
          granularity: scope.granularity,
          delivery: "all",
          search: "",
          policy: [],
          run: [],
        },
        signal,
      );
    },
    enabled: scope.shopId !== null,
    // A new reporting scope must not briefly display another Campaign's data.
    staleTime: 30_000,
  });
}
